export default __webpack_public_path__ + "static/media/tick.eb28c0b4.png";